import React, { useState, useEffect } from 'react';
import '../register/register.css';
import Container from "react-bootstrap/Container";
import { Carousel, Form, Button, Row, Col, Card } from 'react-bootstrap';
import { FaFacebook, FaGoogle } from 'react-icons/fa'
import reg_back from "../../assets/reg-back.png"
import LocalIP from "../../LocalIP";
import axios from "axios"
import { ToastContainer, toast } from "react-toastify";

const Register = () => {

  const [fname, setFname] = useState('');
  const [lname, setLname] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [fnameError, setFnameError] = useState('');
  const [lnameError, setLnameError] = useState('');
  const [emailError, setEmailError] = useState('');
  const [passwordError, setPasswordError] = useState('');

  const clearAll = () => {
    setFname('')
    setLname('')
    setEmail('')
    setPassword('')
    setFnameError('')
    setLnameError('')
    setEmailError('')
    setPasswordError('')
  }

  const validation = () => {
    var Error = false;

    if (fname === "") {
      setFnameError("First Name Required!")
      Error = true;
    } else {
      setFnameError("")
    }

    if (lname === "") {
      setLnameError("Last Name Required!")
      Error = true;
    } else {
      setLnameError("")
    }

    if (email === "") {
      setEmailError("Email Address Required!")
      Error = true;
    } else {
      setEmailError("")
    }

    if (password === "") {
      setPasswordError("Password Required!")
      Error = true;
    } else {
      setPasswordError("")
    }

    if (Error) {
      return false;
    }

    return true;
  };

  const SubmitForm = async (e) => {
    e.preventDefault();
    if (validation()) {

      const url = LocalIP + "user/Register";
      const data = JSON.stringify({
        fname: fname,
        lname: lname,
        email: email,
        password: password
      });
      console.log(data);
      await axios
        .post(url, data, {
          headers: { "Content-Type": "application/json" },
        })
        .then(async (res) => {
          console.log(res.data);
          if (res.data.success === "success") {
            toast.success("Registration Successfull!", {
              position: "top-right",
            });
            clearAll()
          } else if (res.data.err.includes("email_error") || res.data.err.includes("for key 'users.email'")) {
            toast.error("Email Already Exists!", {
              position: "top-right",
            });
          }
        });

    }
  };

  return (
    <Container>
      <br />
      <div id="register" className="web-view">
        <Row>
          <Col className='col-6'>
            <div className="card-view-login hero">
              <Form noValidate onSubmit={SubmitForm} >
                <h2 className="mb-4">Register</h2>
                <FaFacebook className='login-icons' />
                <FaGoogle className='login-icons' />
                <br />
                <Row>
                  <Col md={6}>
                    <Form.Group controlId="formFirstName">
                      <Form.Label className="left-label">First Name</Form.Label>
                      <Form.Control required type="text" placeholder="Enter First Name" value={fname} onChange={e => { setFname(e.target.value) }} />
                      <div style={{ color: "red", textAlign: "left", marginLeft: "10px" }}>{fnameError}</div>
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group controlId="formLastName">
                      <Form.Label className="left-label">Last Name</Form.Label>
                      <Form.Control required type="text" placeholder="Enter Last Name" value={lname} onChange={e => { setLname(e.target.value) }} />
                      <div style={{ color: "red", textAlign: "left", marginLeft: "10px" }}>{lnameError}</div>
                    </Form.Group>
                  </Col>
                </Row>
                <Form.Group controlId="formBasicEmail" className="mt-3">
                  <Form.Label className="left-label">Email address</Form.Label>
                  <Form.Control required type="email" placeholder="Enter email" value={email} onChange={e => { setEmail(e.target.value) }} />
                  <div style={{ color: "red", textAlign: "left", marginLeft: "10px" }}>{emailError}</div>
                </Form.Group>
                <Form.Group controlId="formBasicPassword" className="mt-3">
                  <Form.Label className="left-label">Password</Form.Label>
                  <Form.Control required type="password" placeholder="Password" value={password} onChange={e => { setPassword(e.target.value) }} />
                  <div style={{ color: "red", textAlign: "left", marginLeft: "10px" }}>{passwordError}</div>
                </Form.Group>
                <br />
                <Button type="submit" className="mt-4 w-100 btn btn-warning">
                  Register
                </Button>
                <br />
                <br />
                <h6>Already have an account?</h6>
                <a href="/login" className="mt-4 w-100 btn btn-dark">
                  Login
                </a>
              </Form>
            </div>
          </Col>
          <Col className='col-6'>
            <img
              className="reg-img"
              src={reg_back}
            />
          </Col>
        </Row>
        <br />
      </div>
      <div id="register" className="mobile-view">
        <div className="card-view-register-mobile">
          <Form noValidate onSubmit={SubmitForm} >
            <h2 className="mb-4">Register</h2>
            <FaFacebook className='login-icons' />
            <FaGoogle className='login-icons' />
            <br />
            <Row>
              <Col md={6}>
                <Form.Group controlId="formFirstName">
                  <Form.Label className="left-label">First Name</Form.Label>
                  <Form.Control required type="text" placeholder="Enter First Name" value={fname} onChange={e => { setFname(e.target.value) }} />
                  <div style={{ color: "red", textAlign: "left", marginLeft: "10px" }}>{fnameError}</div>
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group controlId="formLastName">
                  <Form.Label className="left-label">Last Name</Form.Label>
                  <Form.Control required type="text" placeholder="Enter Last Name" value={lname} onChange={e => { setLname(e.target.value) }} />
                  <div style={{ color: "red", textAlign: "left", marginLeft: "10px" }}>{lnameError}</div>
                </Form.Group>
              </Col>
            </Row>
            <Form.Group controlId="formBasicEmail" className="mt-3">
              <Form.Label className="left-label">Email address</Form.Label>
              <Form.Control required type="email" placeholder="Enter email" value={email} onChange={e => { setEmail(e.target.value) }} />
              <div style={{ color: "red", textAlign: "left", marginLeft: "10px" }}>{emailError}</div>
            </Form.Group>
            <Form.Group controlId="formBasicPassword" className="mt-3">
              <Form.Label className="left-label">Password</Form.Label>
              <Form.Control required type="password" placeholder="Password" value={password} onChange={e => { setPassword(e.target.value) }} />
              <div style={{ color: "red", textAlign: "left", marginLeft: "10px" }}>{passwordError}</div>
            </Form.Group>
            <br />
            <Button type="submit" className="mt-4 w-100 btn btn-warning">
              Register
            </Button>
            <br />
            <br />
            <h6>Already have an account?</h6>
            <a href="/login" className="mt-4 w-100 btn btn-dark">
              Login
            </a>
          </Form>
        </div>
        <br />
      </div>
    </Container>
  );
}

export default Register;
